import { AsyncButton } from '@c42/component-library';
import { isLoading } from '@c42/constants';
import ChevronLeft from 'mdi-material-ui/ChevronLeft';
import { Box, Button, Paper, TextField, Typography } from '@mui/material';
import * as React from 'react';
import { useHistory } from 'react-router';
import Text from '../../../shared/Text';
import { SUPPORT_LOGIN_INDEX } from '../../constants/routes';
import LogoIcon from '../logo-icon/LogoIcon';
import LoginAuditLogResults from './login-audit-log-results';
import { useEmployeeDetails } from './useEmployeeDetails';

const LoginAuditLog: React.FC = () => {
  const [employeeId, setEmployeeId] = React.useState('');
  const [hasSearched, setHasSearched] = React.useState(false);

  const history = useHistory();
  const { employeeDetails, loadingState, notFound, error, lookup } = useEmployeeDetails();

  const handleSubmit = (e?: React.FormEvent) => {
    if (e) e.preventDefault();
    const trimmed = employeeId.trim();
    if (!trimmed) return;
    setHasSearched(true);
    lookup(trimmed);
  };

  const isSearchDisabled = !employeeId.trim() || isLoading(loadingState);
  const showResults = hasSearched || notFound || error || !!employeeDetails;

  return (
    <Box maxWidth={1120} minWidth={430} mt="5%" mx="auto" px={2} width="100%">
      <Paper elevation={1}>
        <Box pb={3} pt={3} px={3}>
          <Box alignItems="center" display="flex" justifyContent="space-between" mb={3}>
            <Button
              onClick={() => history.push(SUPPORT_LOGIN_INDEX)}
              startIcon={<ChevronLeft />}
              variant="text"
            >
              {Text.get('audit_log_back_to_login')}
            </Button>
            <LogoIcon />
          </Box>

          <Typography gutterBottom variant="h6">
            {Text.get('audit_log_title')}
          </Typography>

          <form onSubmit={handleSubmit}>
            <Box alignItems="flex-end" display="flex" gap={1.5} mt={2}>
              <Box flexGrow={1}>
                <TextField
                  fullWidth
                  label={Text.get('audit_log_employee_id_label')}
                  onChange={(e) => setEmployeeId(e.target.value)}
                  placeholder={Text.get('audit_log_employee_id_placeholder')}
                  size="small"
                  value={employeeId}
                />
              </Box>
              <AsyncButton
                disabled={isSearchDisabled}
                isLoading={isLoading(loadingState)}
                type="submit"
                variant="contained"
              >
                {Text.get('audit_log_search_button')}
              </AsyncButton>
            </Box>
          </form>

          <Typography color="text.secondary" mt={1} variant="caption">
            {Text.get('audit_log_employee_id_helper')}
          </Typography>
        </Box>
      </Paper>

      {showResults && (
        <Box mt={2}>
          <LoginAuditLogResults
            employeeDetails={employeeDetails}
            error={error}
            notFound={notFound}
          />
        </Box>
      )}
    </Box>
  );
};

export default LoginAuditLog;
